import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetPermissionsDto } from '@/types/dtos/permissions/response/get-permissions.dto.ts';

export const GET_PERMISSIONS_QUERY_KEY = 'get-permissions';

export const usePermissionsQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_PERMISSIONS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return getPermissions({ token: token ?? '' });
    },
  });
};

const getPermissions = async ({ token }: { token: string }): Promise<GetPermissionsDto> => {
  const url = `${import.meta.env.VITE_API_URL}/permissions`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
